const DIR = "/img/upcoming-events";

export const Upcoming = [];